let YourWork = Backbone.Model.extend(
    {
        defaults:
            {
                daysAWeekInOffice: [],
                startTimeInOffice: appConfig.work.inOffice.startTime.defaultValue,
                durationInOffice: appConfig.work.inOffice.duration.defaultValue,
                daysAWeekFromHome: [],
                startTimeFromHome: appConfig.work.fromHome.startTime.defaultValue,
                durationFromHome: appConfig.work.fromHome.duration.defaultValue,
            },

        getDaysAWeekInOffice: function () {
            return this.get('daysAWeekInOffice')
        },
        
        getStartTimeInOffice: function() {
            return parseInt(this.get('startTimeInOffice'));
        },

        getDurationInOffice: function () {
            return parseInt(this.get('durationInOffice'));
        },

        setDaysAWeekInOffice: function (daysAWeek) {
            return this.set('daysAWeekInOffice', daysAWeek)
        },
        
        setStartTimeInOffice: function(mins) {
            this.set('startTimeInOffice', parseInt(mins));
        },

        setDurationInOffice: function (duration) {
            return this.set('durationInOffice', parseInt(duration));
        },

        getDaysAWeekFromHome: function () {
            return this.get('daysAWeekFromHome')
        },

        getStartTimeFromHome: function() {
            return parseInt(this.get('startTimeFromHome'));
        },

        getDurationFromHome: function () {
            return parseInt(this.get('durationFromHome'));
        },

        setDaysAWeekFromHome: function (daysAWeek) {
            return this.set('daysAWeekFromHome', daysAWeek)
        },

        setStartTimeFromHome: function(mins) {
            this.set('startTimeFromHome', parseInt(mins));
        },

        setDurationFromHome: function (duration) {
            return this.set('durationFromHome', parseInt(duration));
        },

        averageUtilisedHours: function () {
            let averageHrs = (
                this.getDaysAWeekInOffice().length * (this.getDurationInOffice()/60.0) +
                this.getDaysAWeekFromHome().length * (this.getDurationFromHome()/60.0)
            ) / 7.0;
            appLogAttr('yourWork','averageUtilisedHours', averageHrs);
            return averageHrs;
        }
    }
);
